import { call, put, takeLatest } from "redux-saga/effects";
import { studentAPI } from "../../../services/student/index"
import { deleteCourse, DELETE_COURSE} from "../../actions/student.action"

function* handleDeleteCourse(action) {
  try {
    const { data : resData} = yield call(studentAPI.deleteCourse, action.payload);
    //extract the data here     
    yield put(deleteCourse.success({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  } catch (e) {
    const {data:resData} = e
    yield put(deleteCourse.failure({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  }
}

function* deleteCourseSaga() {
  yield takeLatest(DELETE_COURSE.REQUEST, handleDeleteCourse);
}

export default deleteCourseSaga;
